import { Headers } from "@angular/http";
import { HEADERS } from "./enums";

interface IHeader {
    key: string;
    value: string;
}

export interface IApiRequestOptionsArgs {
    authenticated?: boolean;
    query?: { [key: string]: any };
    since?: Date;
}

const getDefaults = () => {
    return {
        authenticated: true,
        query: undefined,
        since: undefined
    };
};

export class ApiRequestOptions {

    protected authenticated: boolean;
    protected since: Date;
    protected query: { [key: string]: any } = {};

    protected headers: Headers = new Headers();

    constructor(args?: IApiRequestOptionsArgs) {
        args = { ...getDefaults(), ...args};
        this.setAuthenticated(args.authenticated);
        this.setQuery(args.query);
        this.setSince(args.since);
    }

    clone(): ApiRequestOptions {
        return new ApiRequestOptions({
            authenticated: this.authenticated,
            since: this.since ? new Date(this.since.getDate()): undefined,
            query: {
                ...this.query
            }
        });
    }

    getAuthenticated(): boolean {
        return this.authenticated;
    }

    setAuthenticated(value: boolean): void {
        this.authenticated = value;
    }

    getSince(): Date {
        return this.since;
    }

    /**
     * Sets the 'since' property and sets the correct value for header.
     * Note: the header value must be formatted as RFC2822 see https://gist.github.com/AshKyd/8843581
     * @param since
     */
    setSince(since: Date): void {
        this.since = since;

        if (since) {
            if (this.headers.has(HEADERS.IF_MODIFIED_SINCE)) {
                this.headers.set(HEADERS.IF_MODIFIED_SINCE, since.toUTCString());
            } else {
                this.headers.append(HEADERS.IF_MODIFIED_SINCE, since.toUTCString());
            }
        }
    }

    getQuery(): object {
        return this.query;
    }

    setQuery(query: object): void {
        this.query = query;
    }

    appendHeader(name: string, value: string): void {
        this.headers.append(name, value);
    }

    getHeaders(): Headers {
        return this.headers;
    }
}



// WEBPACK FOOTER //
// ./src/core/services/api/request-options.ts